@if (errorMessage()) {
  <div class="errorMessage">
    {{ errorMessage() }}
  </div>
}
<entity-search [entityName]="entityName" [showAllFilters]="showAllFilters"
               (entitySelected)="goToDetail($event)"
               (newEntityRequested)="newQuote($event)">
  @if (canCreateStockQuote) {
    <button toolbarActions matButton="elevated" class="toolbarButton" type="button" (click)="openStockUnitsDialog()">
      <mat-icon class="size-16">local_shipping</mat-icon>
      <label class="buttonLabel"><span class="quickBrand">Quick</span> Units</label>
    </button>
  }
</entity-search>
